/**
 * API-Keys Fixture.
 * Quelle: 01_apis/01_core.api.valitype.net/ADMIN/views.md → #/api-keys
 */

export const KNOWN_SCOPES = [
  'saas.users.read',
  'saas.subscriptions.read',
  'saas.invoices.read',
  'saas.services.read',
  'saas.orders.read',
  'saas.usage.write',
  'saas.usage.read',
  'saas.sso.mint',
  'billing.read',
  'services.read',
  'services.write',
];

function randomHex(len) {
  const chars = '0123456789abcdef';
  let s = '';
  for (let i = 0; i < len; i += 1) s += chars[Math.floor(Math.random() * 16)];
  return s;
}

export function apiKeysFixture() {
  const now = Date.now();
  return {
    keys: [
      {
        id: 1001,
        label: 'valiKey backend (prod)',
        prefix: 'vlt_live_a1b2',
        scopes: ['saas.users.read', 'saas.subscriptions.read', 'saas.invoices.read', 'saas.sso.mint'],
        status: 'active',
        lastUsedAt: new Date(now - 4 * 60_000).toISOString(),
        expiresAt: null,
        createdAt: new Date(now - 180 * 86_400_000).toISOString(),
      },
      {
        id: 1002,
        label: 'valiKey backend (staging)',
        prefix: 'vlt_test_c3d4',
        scopes: ['saas.users.read', 'saas.subscriptions.read', 'saas.usage.write'],
        status: 'active',
        lastUsedAt: new Date(now - 2 * 3_600_000).toISOString(),
        expiresAt: new Date(now + 30 * 86_400_000).toISOString(),
        createdAt: new Date(now - 60 * 86_400_000).toISOString(),
      },
      {
        id: 1003,
        label: 'Usage-Ingest Worker',
        prefix: 'vlt_live_e5f6',
        scopes: ['saas.usage.write'],
        status: 'active',
        lastUsedAt: new Date(now - 30_000).toISOString(),
        expiresAt: null,
        createdAt: new Date(now - 45 * 86_400_000).toISOString(),
      },
      {
        id: 1004,
        label: 'Legacy migration tool',
        prefix: 'vlt_live_g7h8',
        scopes: ['saas.users.read', 'saas.orders.read'],
        status: 'revoked',
        lastUsedAt: new Date(now - 90 * 86_400_000).toISOString(),
        expiresAt: null,
        createdAt: new Date(now - 365 * 86_400_000).toISOString(),
      },
    ],
  };
}

/** Simuliert POST /v1/admin/api-keys — liefert Plaintext-Secret EINMALIG. */
export function createApiKeyFixture({ label, scopes, expiresAt }) {
  const id = 1100 + Math.floor(Math.random() * 100);
  const prefix = `vlt_live_${randomHex(4)}`;
  const plaintext = `${prefix}_${randomHex(48)}`;
  return {
    id,
    label,
    prefix,
    scopes,
    status: 'active',
    lastUsedAt: null,
    expiresAt: expiresAt ?? null,
    createdAt: new Date().toISOString(),
    plaintext, // NUR aus dem Create-Response — danach nicht mehr lesbar
  };
}

/** Simuliert POST /v1/admin/api-keys/:id/rotate-secret — alter Plaintext sofort tot. */
export function rotateApiKeyFixture(id) {
  const prefix = `vlt_live_${randomHex(4)}`;
  return {
    id,
    prefix,
    plaintext: `${prefix}_${randomHex(48)}`,
    rotatedAt: new Date().toISOString(),
  };
}
